import {
  SelectionChangeType,
  SelectionForm
} from '@/app/platform/platform-management/user-group-block/selection-form';
import { UserGroupEntity } from '@/app/platform/platform-data/models/user-group.entity';
import { EgiAppEntity } from '@/app/platform/platform-data/models/egi-app.entity';

export abstract class AbstractAuthorizationSelectionForm<T> {
  protected readonly selectionForm = new SelectionForm<string>();
  protected egiApp: EgiAppEntity = EgiAppEntity.createDefault();
  protected userGroup = UserGroupEntity.createDefault();

  isDirty(): boolean {
    return this.selectionForm.dirty;
  }

  init(egiApp: EgiAppEntity, userGroup: UserGroupEntity) {
    this.egiApp = egiApp;
    this.userGroup = userGroup;
  }

  reset(): void {
    this.selectionForm.reset();
  }

  abstract selectAll(): void;

  abstract toggle(...args: AnyArgs): boolean;

  abstract select(...args: AnyArgs): void;

  abstract getChanges(): ChangedItem<T>[];

  abstract isSelected(...args: AnyArgs): boolean;
}

export interface ChangedItem<T> {
  item: T;
  type: SelectionChangeType;
}

type AnyArgs = any[];
